import { useRole } from "@/contexts/RoleContext";
import { CollaborateurDashboard } from "./collaborateur/CollaborateurDashboard";
import { CLevelDashboard } from "./CLevelDashboard";

export function DashboardPage() {
  const { role } = useRole();

  if (role === "collaborateur") {
    return <CollaborateurDashboard />;
  }

  if (role === "admin" || role === "c_level") {
    return <CLevelDashboard />;
  }

  return (
    <div>
      <div className="text-text-muted text-sm">
        {/* TODO: Dashboard content for other roles */}
      </div>
    </div>
  );
}
